"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartImportComponentsFromDatasheetJobResult = exports.StartImportComponentsFromDatasheetJobFailure = exports.StartImportComponentsFromDatasheetJobSuccess = exports.startImportComponentsFromDatasheetJobRequest = exports.importComponentsFromDatasheetJobSchema = exports.importComponentsFromDatasheetJobUidSchema = void 0;
exports.importComponentsFromDatasheetJobUid = importComponentsFromDatasheetJobUid;
exports.createImportComponentsFromDatasheetJob = createImportComponentsFromDatasheetJob;
const zod_1 = require("zod");
const identifier_1 = require("../identifier");
const property_1 = require("../property");
const shared_1 = require("./shared");
const status_1 = require("./status");
function importComponentsFromDatasheetJobUid(id) {
    return `import-ds-comp-${id}`;
}
exports.importComponentsFromDatasheetJobUidSchema = zod_1.z.custom((s) => typeof s === "string" && s.startsWith("import-ds-comp"));
const importedComponentSchema = zod_1.z.object({
    importedToProjectUid: zod_1.z.string(),
    projectSlug: zod_1.z.string(),
    projectOwnerHandle: zod_1.z.string(),
});
const importComponentsFromDatasheetCompleteSchema = (0, status_1.createCompleteStatusSchema)(importedComponentSchema);
const importComponentsFromDatasheetJobStatus = zod_1.z.discriminatedUnion("type", [
    status_1.failedStatusSchema,
    status_1.runningStatusSchema,
    status_1.pendingStatusSchema,
    importComponentsFromDatasheetCompleteSchema,
]);
exports.importComponentsFromDatasheetJobSchema = zod_1.z.object({
    // NOTE: We polished the type and schema name for this job to make
    // them more consistent, but decided to keep the type literal unchanged
    // because changing it requires backward compatibility across cloud
    // functions, storage triggers and Temporal, its a bit risky.
    // As long as the type/schema names are consistent, we are good
    type: zod_1.z.literal("importComponentFromDatasheet"),
    submittedByUserUid: zod_1.z.string(),
    // Not updating naming here for backwards compat
    pdfUid: shared_1.importArtifactUidSchema,
    jobUid: exports.importComponentsFromDatasheetJobUidSchema,
    workflowId: zod_1.z.string(),
    templateProjectUid: zod_1.z.string().optional(),
    targetComponent: shared_1.importableComponentInfoSchema,
    jobStatus: importComponentsFromDatasheetJobStatus,
});
function createImportComponentsFromDatasheetJob(submittedByUserUid, pdfUid, jobUid, workflowId, targetComponent, templateProjectUid) {
    return {
        type: "importComponentFromDatasheet",
        submittedByUserUid,
        pdfUid,
        jobUid,
        workflowId,
        jobStatus: (0, status_1.jobPendingStatus)(),
        targetComponent,
        templateProjectUid,
    };
}
exports.startImportComponentsFromDatasheetJobRequest = zod_1.z.object({
    // Not updating naming here for backwards compat
    pdfUid: zod_1.z.custom(),
    targetComponent: shared_1.importableComponentInfoSchema,
    /**
     * When specified, will use this partType to do dynamic properties extraction.
     * When not specified, will let copilot to infer the part type first
     */
    partTypeForDynamicPropertyExtraction: zod_1.z.string().nullish(),
    /**
     * Uid of a template project, which is used as a template to extract properties.
     * Note that when `propertiesForExtraction` is specified, will use that list of property instead
     * of extracting from a template project
     */
    templateProjectUid: shared_1.optionalString,
    /**
     * Optional list of property for extraction, note that when specified, will always
     * use this list for property extraction
     */
    propertiesForExtraction: zod_1.z.array(property_1.PropertyData).nullish(),
    organizationUid: identifier_1.optionalOrganizationUid,
    // Optional options to configure the job
    options: zod_1.z
        .object({
        // When specified, will use this value to override the one from feature flag
        enableChartExtraction: zod_1.z.boolean().nullish(),
        enableTableExtraction: zod_1.z.boolean().default(true),
    })
        .nullish(),
});
exports.StartImportComponentsFromDatasheetJobSuccess = zod_1.z.object({
    type: zod_1.z.literal("success"),
    jobUid: exports.importComponentsFromDatasheetJobUidSchema,
});
exports.StartImportComponentsFromDatasheetJobFailure = zod_1.z.object({
    type: zod_1.z.literal("failure"),
    failureReason: zod_1.z.string(),
});
exports.StartImportComponentsFromDatasheetJobResult = zod_1.z.discriminatedUnion("type", [
    exports.StartImportComponentsFromDatasheetJobFailure,
    exports.StartImportComponentsFromDatasheetJobSuccess,
]);
//# sourceMappingURL=importComponentsFromDatasheet.js.map